import { browser } from '$app/environment';

export function copyToClipboard(elt: HTMLElement) {
	if (!browser) {
		return;
	}
	// Select the div content
	const range = document.createRange();
	range.selectNode(elt);
	window.getSelection().removeAllRanges(); // Clear any current selections
	window.getSelection().addRange(range); // Add the range to the selection

	// Copy the selection to the clipboard
	document.execCommand('copy');
	// Clean up the selection
	//window.getSelection().removeAllRanges();
}
